<template>
  <div class="px-4 pb-4 w-[800px]">

    <h3 class="py-2 text-xl">Export</h3>
    <p>Was möchten Sie exportieren?</p>


    <div v-if="isLoading" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div class="spinner"></div>
    </div>

    <div class="flex flex-col gap-4">

      <div class="grid grid-cols-3 gap-2 mt-4 text-center">
        <div @click="modus = 'magazine'" data-ui="export-magazine"
             class=" py-2 px-2 cursor-pointer hover:bg-trader-blue hover:text-white cursor-pointer"
             :class="modus === 'magazine' ? 'bg-trader-blue text-white' : 'bg-trader-gray'"
        >
          <div class="text-xl"><i class="fa-solid fa-book-open"></i></div>
          Werbemittel
        </div>

        <div @click="modus = 'page'" data-ui="export-page"
             class="py-2 px-2 cursor-pointer hover:bg-trader-blue hover:text-white cursor-pointer"
             :class="modus === 'page' ? 'bg-trader-blue text-white' : 'bg-trader-gray'"
        >
          <div class="text-xl"><i class="fa-solid fa-file"></i></div>
          Seiten
        </div>

        <div @click="modus = 'products'" data-ui="export-products"
             class="py-2 px-2 cursor-pointer hover:bg-trader-blue hover:text-white cursor-pointer"
             :class="modus === 'products' ? 'bg-trader-blue text-white' : 'bg-trader-gray'"
        >
          <div class="text-xl"><i class="fa-solid fa-note-sticky"></i></div>
          Artikel
        </div>
      </div>

      <div>
        <h3 class="py-2 text-xl">Export Einstellungen</h3>

        <div class="grid grid-cols-[6rem,1fr] items-center gap-1">


          <template v-if="modus === 'products'">
            <span>Artikel:</span>
            <div>
              <select name="source" id="source" class="w-full bg-trader-gray p-2" v-model="source">
                <option value="0">Alle Artikel aus diesem Werbemittel</option>
                <option value="1">Alle Artikel dieser Seite</option>
                <option value="2">Nur der ausgewählte Artikel von dieser Seite</option>
              </select>
            </div>

            <span>Artikelvorlage:</span>
            <div>
              <select name="template" id="template" class="w-full bg-trader-gray p-2" v-model="type">
                <option value="0">Zugewiesene Artikelvorlage</option>
                <!-- <option value="1">Zusätzlich ausgewählte Artikelvorlagen</option> -->
                <option value="2">Artikelvorlange auswählen</option>
              </select>
            </div>

          </template>
          <template v-if="type == 2">

            <span></span>
            <div>
              <div class="max-h-[400px] flex gap-1">

                <div class=" overflow-auto bg-trader-dark-gray">
                  <div v-for="category in templateCategories" class="flex gap-2">
                    <div class="p-1 cursor-pointer w-full" @click="onSelectCategory(category.id)"
                         :class="selectedCategory === category.id ? 'bg-trader-blue text-white' : ''">
                      <span>{{ category.name }}</span>
                    </div>
                  </div>
                </div>

                <div class=" overflow-auto bg-trader-dark-gray flex-grow">
                  <div v-for="template in templates" class="flex gap-2">
                    <div class="p-1 cursor-pointer w-full flex items-center" @click="onSelectTemplate(template.id)"
                         :class="selectedTemplate === template.id ? 'bg-trader-blue text-white' : ''">

                      <div v-if="template.exists" class="bg-green-600 rounded-2xl h-2 w-2 mr-2"></div>
                      <div v-else class="bg-red-600 rounded-2xl h-2 w-2 mr-2"></div>
                      <span>{{ template.name }}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </template>

          <template v-if="modus === 'page'">
            <span>Seite:</span>
            <div>
              <div class="flex flex-col gap-2">
                <div v-if="this.selectedPages.length == 0" class="bg-trader-red text-trader-dark-red p-2">
                  Bitte mindestens eine Seite auswählen!
                </div>
                <div class="flex flex-wrap gap-1 items-center">
                  <div v-for="page in magazinePagePositions" class="py-2 text-center w-8 cursor-pointer"
                       @click="togglePageSelection(page)"
                       :class="{'bg-trader-gray' : !selectedPages.includes(page) , 'bg-trader-blue text-white': selectedPages.includes(page)}">
                    {{ page }}
                  </div>
                </div>
              </div>
            </div>
          </template>


          <template v-if="modus === 'page' && this.page.marketId != 0">
            <span>Markt:</span>
            <div>
              <div class="flex flex-col gap-2">
                <div v-if="this.selectedMarkets.length == 0" class="bg-trader-red text-trader-dark-red p-2">
                  Bitte mindestens einen Markt auswählen!
                </div>
                <div class="flex flex-wrap gap-1 items-center">
                  <div v-for="market in marketList" class="py-2 text-center w-8 cursor-pointer"
                       @click="toggleMarketSelection(market)"
                       :class="this?.selectedMarkets?.indexOf(market) >= 0 ? 'bg-trader-blue text-white' : 'bg-trader-gray'">
                    {{ market.name }}
                  </div>
                </div>
                <div class="flex gap-1 justify-end">
                  <div class="bg-trader-gray py-1 px-2 cursor-pointer" @click="selectAllMarkets">Alles
                    Auswählen
                  </div>
                  <div class="bg-trader-gray py-1 px-2 cursor-pointer" @click="deselectAllMarkets">Alles
                    Abwählen
                  </div>
                </div>
              </div>
            </div>
          </template>


          <span>Ausgabeformat:</span>
          <div>
            <select name="format" id="format" class="w-full bg-trader-gray p-2" v-model="format">
              <option value="idml">.idml - Adobe InDesign Markup Language</option>
              <!-- <option value="idms">InDesign Snippet (.idms)</option> -->
              <!-- <option value="png">.png - Portable Network Graphics</option> -->
              <!-- <option value="jpeg">JPEG</option> -->
              <!-- <option value="pdf">.pdf - Portable Document Format</option>  -->
            </select>
          </div>

        </div>


      </div>


      <div class="flex gap-2 w-full mt-2">
        <a class="flex-grow bg-trader-red text-trader-dark-red p-2 text-center" @click="hideWindow"
           data-ui="close-export">Abbrechen</a>
        <a class="flex-grow bg-trader-green text-trader-dark-green p-2 text-center"
           @click="startDownload">Exportieren</a>
      </div>


      <div>{{exportUrl}}</div>


    </div>


  </div>

  <!--
<a :href="'/api/v3/export/magazine/'+ page.magazineId" download @click="hideWindow"
   class="bg-trader-gray py-2 px-2 cursor-pointer hover:bg-trader-blue hover:text-white">
  <div class="text-xl"><i class="fa-solid fa-book-open"></i></div>
  Dieses Werbemittel
</a>

<a :href="'/api/v3/export/page/'+ page.pageId" download @click="hideWindow"
   class="bg-trader-gray py-2 px-2 cursor-pointer hover:bg-trader-blue hover:text-white">
  <div class="text-xl"><i class="fa-solid fa-file"></i></div>
  Diese Seite
</a>

<a :href="'/api/v3/export/products/'+ page.magazineId" download @click="hideWindow"
   class="bg-trader-gray py-2 px-2 cursor-pointer hover:bg-trader-blue hover:text-white">
  <div class="text-xl"><i class="fa-solid fa-note-sticky"></i></div>
  Die Artikel dieses Werbemittels
</a>
-->
</template>


<script>
import {mapGetters, mapState} from "vuex";
import axios from "axios";
import {query} from "@/graphql";

export default {
  name: "InDesignExportModal",
  computed: {
    ...mapState({
      pageId: state => state.pageId,
      productId: state => state.productId,
      magazinePagePositions: state => state.magazinePagePositions,
    }),
    ...mapState('page', ['page']),
    ...mapGetters('page', ['pageSide']),
    ...mapGetters('page', ['isNonFood']),
    ...mapState('user', ['userData']),

    exportUrl() {
      if (this.modus === 'magazine') {
        return '/api/v3/export/magazine/' + this.page.magazineId + '/' + this.format;
      }
      if (this.modus === 'page') {
        if (this.selectedPages.length == 0) {
          return;
        }

        if (this.marketList?.length > 0 && this.selectedMarkets?.length == 0) {
          return;
        }

        let markets = this?.selectedMarkets?.map(market => market?.marketId)?.join(',') || '0';
        return '/api/v3/export/magazine/' + this.page.magazineId + '/pages/' + this.selectedPages.join(',') + '/' + markets + '/' + this.format;
      }
      if (this.modus === 'products') {
        return '/api/v3/export/magazine/' + this.page.magazineId + '/page/' + this.page.pageId + '/product/' + this.productId + '/source/' + this.source + '/type/' + this.type + '/template/' + this.selectedTemplate + '/' + this.format;
      }
    }
  },
  props: {
    marketList: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      modus: 'page', //'page', //'magazine',
      source: 0,
      type: 0,
      format: 'idml',
      isLoading: false,
      pageStart: 0,
      pageEnd: 0,
      selectedPages: [],
      selectedMarkets: [],
      templateCategories: [],
      selectedCategory: null,
      templates: [],
      selectedTemplate: null,
    }
  },
  watch: {
    pageId() {
      this.selectedPages = [this.page.pagePosition];
      try {
        const market = this.marketList.filter(m => m.marketId == this.page.marketId);
        this.selectedMarkets = [market[0]];
      } catch (e) {
        console.error('Error:', e);
      }
    }
  },
  methods: {
    async onSelectCategory(categoryId) {
      if (this.selectedCategory === categoryId) {
        this.selectedTemplate = null;
        this.selectedCategory = null;
        this.templates = [];
      } else {
        this.selectedTemplate = null;
        this.selectedCategory = categoryId;
        const [templates, err] = await query.getInDesignTemplates('articletemplate', categoryId);
        this.templates = err ? [] : templates;
      }
    },
    onSelectTemplate(templateId) {
      if (this.selectedTemplate === templateId) {
        this.selectedTemplate = null;
      } else {
        this.selectedTemplate = templateId;
      }

    },
    selectAllMarkets() {
      this.selectedMarkets = this.marketList;
    },
    deselectAllMarkets() {
      this.selectedMarkets = [];
    },
    toggleMarketSelection(market) {
      if (this.selectedMarkets.indexOf(market) >= 0) {
        this.selectedMarkets = this.selectedMarkets.filter(selectedMarket => selectedMarket !== market);
      } else {
        this.selectedMarkets.push(market);
      }
    },
    togglePageSelection(pagePosition) {
      if (this.selectedPages.includes(pagePosition)) {
        this.selectedPages = this.selectedPages.filter((item) => {
          return item != pagePosition
        });
      } else {
        this.selectedPages.push(pagePosition);
      }
    },
    hideWindow() {
      this.$emit('close-modal');
    },
    startDownload() {
      this.isLoading = true;
      axios({
        url: this.exportUrl,
        method: 'GET',
        responseType: 'blob'
      })
          .then(response => {
            //get the filename from the content-disposition header
            const filename = response.headers['content-disposition'].split('filename=')[1];
            const fixedFilename = filename.replace(/"/g, '');
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fixedFilename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.isLoading = false;
            this.$emit('close-modal');
          })
          .catch(error => {
            console.error('Fehler beim Download:', error);
            this.isLoading = false;
            this.$emit('close-modal');
          });
    },
  },
  async mounted() {
    this.selectedPages = [this.page.pagePosition];
    try {
      const market = this.marketList.filter(m => m.marketId == this.page.marketId);
      this.selectedMarkets = [market[0]];
    } catch (e) {
      console.error('Error:', e);
    }

    const [categories, err] = await query.getInDesignTemplateCategories('articletemplate');
    this.templateCategories = err ? [] : categories;
  }
}
</script>


<style scoped>
.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>